import { createRouter, createWebHistory } from 'vue-router';
import AboutPage from '../components/AboutPage.vue';
import EnglishPage from '../components/EnglishPage.vue';

//蜑｣驕・
import KendouPage from '../components/KendouPage.vue';
import terminologyPage from '../components/kendou/TerminologyPage.vue';
import kendouSeriesPage from '../components/kendou/KendouSeriesPage.vue';
import kendouTopicPage from '../components/kendou/KendouTopicPage.vue';
import kendouTechniquePage from '../components/kendou/KendouTechniquePage.vue';
import kendouTermPage from '../components/kendou/KendouTermPage.vue';
import kendouAnalyzerPage from '../components/kendou/KendouAnalyzerPage.vue';
import kendouAnalyzerJobPage from '../components/kendou/KendouAnalyzerJobPage.vue';
import englishdectionary from '../components/english/EnglishDectionary.vue';
import root_ag_act from '../components/english/root1_ag(act).vue'
import rootDetail from '../components/english/RootDetail.vue';
import wordDetail from '../components/english/WordDetail.vue';
import practiceModeSelect from '../components/english/PracticeModeSelect.vue';
import practiceOptions from '../components/english/PracticeOptions.vue';
import practiceTyping from '../components/english/PracticeTyping.vue';
import aiRootPractice from '../components/english/AiRootPractice.vue';
// 莠碑ｼｪ譖ｸINDEX
import gorinsyoPage from '../components/gorinsyoPage.vue';
import FiveBookIntroDuction from '../components/fivecieclebook/FiveCircleBookIntroduction.vue';
import Preface from '../components/fivecieclebook/FiveCircleBookPreface.vue';
import JiNoMakiPreface from '../components/fivecieclebook/jiNoMakiPreface.vue';
import gorinsyo0003 from '../components/fivecieclebook/goRinSyo0003.vue';
import gorinsyo0004 from '../components/fivecieclebook/goRinSyo0004.vue';
import gorinsyo0005 from '../components/fivecieclebook/goRinSyo0005.vue';
import gorinsyo0006 from '../components/fivecieclebook/goRinSyo0006.vue';
import gorinsyo0007 from '../components/fivecieclebook/goRinSyo0007.vue';
import gorinsyo0008 from '../components/fivecieclebook/goRinSyo0008.vue';
import gorinsyo0009 from '../components/fivecieclebook/goRinSyo0009.vue';
import gorinsyo0010 from '../components/fivecieclebook/goRinSyo0010.vue';
import gorinsyo0011 from '../components/fivecieclebook/goRinSyo0011.vue';
import gorinsyo0012 from '../components/fivecieclebook/goRinSyo0012.vue';
import gorinsyo0013 from '../components/fivecieclebook/goRinSyo0013.vue';
import gorinsyo0014 from '../components/fivecieclebook/goRinSyo0014.vue';
import gorinsyo0015 from '../components/fivecieclebook/goRinSyo0015.vue';
import gorinsyo0016 from '../components/fivecieclebook/goRinSyo0016.vue';
import gorinsyo0017 from '../components/fivecieclebook/goRinSyo0017.vue';
import gorinsyo0018 from '../components/fivecieclebook/goRinSyo0018.vue';
import gorinsyo0019 from '../components/fivecieclebook/goRinSyo0019.vue';
import gorinsyo0020 from '../components/fivecieclebook/goRinSyo0020.vue';
import gorinsyo0021 from '../components/fivecieclebook/goRinSyo0021.vue';
import gorinsyo0022 from '../components/fivecieclebook/goRinSyo0022.vue';
import gorinsyo0023 from '../components/fivecieclebook/goRinSyo0023.vue';
import gorinsyo0024 from '../components/fivecieclebook/goRinSyo0024.vue';
import gorinsyo0025 from '../components/fivecieclebook/goRinSyo0025.vue';
import gorinsyo0026 from '../components/fivecieclebook/goRinSyo0026.vue';
import gorinsyo0027 from '../components/fivecieclebook/goRinSyo0027.vue';
import gorinsyo0028 from '../components/fivecieclebook/goRinSyo0028.vue';
import gorinsyo0029 from '../components/fivecieclebook/goRinSyo0029.vue';
import gorinsyo0030 from '../components/fivecieclebook/goRinSyo0030.vue';
import gorinsyo0031 from '../components/fivecieclebook/goRinSyo0031.vue';
import gorinsyo0032 from '../components/fivecieclebook/goRinSyo0032.vue';
import gorinsyo0033 from '../components/fivecieclebook/goRinSyo0033.vue';
import gorinsyo0034 from '../components/fivecieclebook/goRinSyo0034.vue';
import gorinsyo0035 from '../components/fivecieclebook/goRinSyo0035.vue';
import gorinsyo0036 from '../components/fivecieclebook/goRinSyo0036.vue';
import gorinsyo0037 from '../components/fivecieclebook/goRinSyo0037.vue';
import gorinsyo0038 from '../components/fivecieclebook/goRinSyo0038.vue';
import gorinsyo0039 from '../components/fivecieclebook/goRinSyo0039.vue';
import gorinsyo0040 from '../components/fivecieclebook/goRinSyo0040.vue';
import gorinsyo0041 from '../components/fivecieclebook/goRinSyo0041.vue';
import gorinsyo0042 from '../components/fivecieclebook/goRinSyo0042.vue';
import gorinsyo0043 from '../components/fivecieclebook/goRinSyo0043.vue';
import gorinsyo0044 from '../components/fivecieclebook/goRinSyo0044.vue';
import gorinsyo0045 from '../components/fivecieclebook/goRinSyo0045.vue';
import gorinsyo0046 from '../components/fivecieclebook/goRinSyo0046.vue';
import gorinsyo0047 from '../components/fivecieclebook/goRinSyo0047.vue';
import gorinsyo0048 from '../components/fivecieclebook/goRinSyo0048.vue';
import gorinsyo0049 from '../components/fivecieclebook/goRinSyo0049.vue';
import gorinsyo0050 from '../components/fivecieclebook/goRinSyo0050.vue';
import gorinsyo0051 from '../components/fivecieclebook/goRinSyo0051.vue';
import gorinsyo0052 from '../components/fivecieclebook/goRinSyo0052.vue';
import gorinsyo0053 from '../components/fivecieclebook/goRinSyo0053.vue';
import gorinsyo0054 from '../components/fivecieclebook/goRinSyo0054.vue';
import gorinsyo0055 from '../components/fivecieclebook/goRinSyo0055.vue';
import gorinsyo0056 from '../components/fivecieclebook/goRinSyo0056.vue';
import gorinsyo0057 from '../components/fivecieclebook/goRinSyo0057.vue';
import gorinsyo0058 from '../components/fivecieclebook/goRinSyo0058.vue';
import gorinsyo0059 from '../components/fivecieclebook/goRinSyo0059.vue';
import gorinsyo0060 from '../components/fivecieclebook/goRinSyo0060.vue';
import gorinsyo0061 from '../components/fivecieclebook/goRinSyo0061.vue';
import gorinsyo0062 from '../components/fivecieclebook/goRinSyo0062.vue';
import gorinsyo0063 from '../components/fivecieclebook/goRinSyo0063.vue';
import gorinsyo0064 from '../components/fivecieclebook/goRinSyo0064.vue';
import gorinsyo0065 from '../components/fivecieclebook/goRinSyo0065.vue';
import gorinsyo0066 from '../components/fivecieclebook/goRinSyo0066.vue';
import gorinsyo0067 from '../components/fivecieclebook/goRinSyo0067.vue';
import gorinsyo0068 from '../components/fivecieclebook/goRinSyo0068.vue';
import gorinsyo0069 from '../components/fivecieclebook/goRinSyo0069.vue';
import gorinsyo0070 from '../components/fivecieclebook/goRinSyo0070.vue';
import gorinsyo0071 from '../components/fivecieclebook/goRinSyo0071.vue';
import gorinsyo0072 from '../components/fivecieclebook/goRinSyo0072.vue';
import gorinsyo0073 from '../components/fivecieclebook/goRinSyo0073.vue';
import gorinsyo0074 from '../components/fivecieclebook/goRinSyo0074.vue';
import gorinsyo0075 from '../components/fivecieclebook/goRinSyo0075.vue';
import gorinsyo0076 from '../components/fivecieclebook/goRinSyo0076.vue';
import gorinsyo0077 from '../components/fivecieclebook/goRinSyo0077.vue';
import gorinsyo0078 from '../components/fivecieclebook/goRinSyo0078.vue';
import gorinsyo0079 from '../components/fivecieclebook/goRinSyo0079.vue';
import gorinsyo0080 from '../components/fivecieclebook/goRinSyo0080.vue';
import gorinsyo0081 from '../components/fivecieclebook/goRinSyo0081.vue';
import gorinsyo0082 from '../components/fivecieclebook/goRinSyo0082.vue';
import gorinsyo0083 from '../components/fivecieclebook/goRinSyo0083.vue';
import gorinsyo0084 from '../components/fivecieclebook/goRinSyo0084.vue';
import gorinsyo0085 from '../components/fivecieclebook/goRinSyo0085.vue';




//HTML
import HTML from '../components/HTMLLearn.vue';
import Introduction from '../components/HTML/HTML0000.vue';
import HTML0001 from '../components/HTML/HTML0001.vue';
import HTML0002 from '../components/HTML/HTML0002.vue';
import HTML0003 from '../components/HTML/HTML0003.vue';
import HTML0004 from '../components/HTML/HTML0004.vue';
import HTML0005 from '../components/HTML/HTML0005.vue';
// import HTML0006 from '../components/HTML/HTML0006.vue';
// import HTML0007 from '../components/HTML/HTML0007.vue';
// import HTML0008 from '../components/HTML/HTML0008.vue';
// import HTML0009 from '../components/HTML/HTML0009.vue';
// import HTML0010 from '../components/HTML/HTML0010.vue';
// import HTML0011 from '../components/HTML/HTML0011.vue';
// import HTML0012 from '../components/HTML/HTML0012.vue';
// import HTML0013 from '../components/HTML/HTML0013.vue';
// import HTML0014 from '../components/HTML/HTML0014.vue';
// import HTML0015 from '../components/HTML/HTML0015.vue';
// import HTML0016 from '../components/HTML/HTML0016.vue';
// import HTML0017 from '../components/HTML/HTML0017.vue';
// import HTML0018 from '../components/HTML/HTML0018.vue';
// import HTML0019 from '@/components/HTML/HTML0019.vue';


const routes = [
    {
        path: '/', component: KendouPage,
        children:[
            { path: '', component: terminologyPage},
            { path: '/KendouPage/terminology', component: terminologyPage},
            { path: '/KendouPage/roude', redirect: '/KendouPage/topic/road-before-second-dan-002-what-is-kendo' },
            { path: '/KendouPage/HakamaAndKendougi', redirect: '/KendouPage/topic/road-before-second-dan-003-kendo-gi-and-hakama' },
            { path: '/KendouPage/series/:slug', component: kendouSeriesPage },
            { path: '/KendouPage/topic/:slug', component: kendouTopicPage },
            { path: '/KendouPage/technique/:slug', component: kendouTechniquePage },
            { path: '/KendouPage/term/:termId', component: kendouTermPage },
            { path: '/KendouPage/analyzer', component: kendouAnalyzerPage },
            { path: '/KendouPage/analyzer/:jobId', component: kendouAnalyzerJobPage },
        ]
    },
    {
        path: '/fivecirclebook', component: gorinsyoPage,
        children:[
            { path: '', component: FiveBookIntroDuction},
            { path: '/fivecieclebook/Introduction', component: FiveBookIntroDuction},
            { path: '/fivecieclebook/Preface', component: Preface},
            { path: '/fivecieclebook/JiNomakiPreface', component: JiNoMakiPreface },
            { path: '/fivecieclebook/gorinsyo0003', component: gorinsyo0003 },
            { path: '/fivecieclebook/gorinsyo0004', component: gorinsyo0004 },
            { path: '/fivecieclebook/gorinsyo0005', component: gorinsyo0005 },
            { path: '/fivecieclebook/gorinsyo0006', component: gorinsyo0006 },
            { path: '/fivecieclebook/gorinsyo0007', component: gorinsyo0007 },
            { path: '/fivecieclebook/gorinsyo0008', component: gorinsyo0008 },
            { path: '/fivecieclebook/gorinsyo0009', component: gorinsyo0009 },
            { path: '/fivecieclebook/gorinsyo0010', component: gorinsyo0010 },
            { path: '/fivecieclebook/gorinsyo0011', component: gorinsyo0011 },
            { path: '/fivecieclebook/gorinsyo0012', component: gorinsyo0012 },
            { path: '/fivecieclebook/gorinsyo0013', component: gorinsyo0013 },
            { path: '/fivecieclebook/gorinsyo0014', component: gorinsyo0014 },
            { path: '/fivecieclebook/gorinsyo0015', component: gorinsyo0015 },
            { path: '/fivecieclebook/gorinsyo0016', component: gorinsyo0016 },
            { path: '/fivecieclebook/gorinsyo0017', component: gorinsyo0017 },
            { path: '/fivecieclebook/gorinsyo0018', component: gorinsyo0018 },
            { path: '/fivecieclebook/gorinsyo0019', component: gorinsyo0019 },
            { path: '/fivecieclebook/gorinsyo0020', component: gorinsyo0020 },
            { path: '/fivecieclebook/gorinsyo0021', component: gorinsyo0021 },
            { path: '/fivecieclebook/gorinsyo0022', component: gorinsyo0022 },
            { path: '/fivecieclebook/gorinsyo0023', component: gorinsyo0023 },
            { path: '/fivecieclebook/gorinsyo0024', component: gorinsyo0024 },
            { path: '/fivecieclebook/gorinsyo0025', component: gorinsyo0025 },
            { path: '/fivecieclebook/gorinsyo0026', component: gorinsyo0026 },
            { path: '/fivecieclebook/gorinsyo0027', component: gorinsyo0027 },
            { path: '/fivecieclebook/gorinsyo0028', component: gorinsyo0028 },
            { path: '/fivecieclebook/gorinsyo0029', component: gorinsyo0029 },
            { path: '/fivecieclebook/gorinsyo0030', component: gorinsyo0030 },
            { path: '/fivecieclebook/gorinsyo0031', component: gorinsyo0031 },
            { path: '/fivecieclebook/gorinsyo0032', component: gorinsyo0032 },
            { path: '/fivecieclebook/gorinsyo0033', component: gorinsyo0033 },
            { path: '/fivecieclebook/gorinsyo0034', component: gorinsyo0034 },
            { path: '/fivecieclebook/gorinsyo0035', component: gorinsyo0035 },
            { path: '/fivecieclebook/gorinsyo0036', component: gorinsyo0036 },
            { path: '/fivecieclebook/gorinsyo0037', component: gorinsyo0037 },
            { path: '/fivecieclebook/gorinsyo0038', component: gorinsyo0038 },
            { path: '/fivecieclebook/gorinsyo0039', component: gorinsyo0039 },
            { path: '/fivecieclebook/gorinsyo0040', component: gorinsyo0040 },
            { path: '/fivecieclebook/gorinsyo0041', component: gorinsyo0041 },
            { path: '/fivecieclebook/gorinsyo0042', component: gorinsyo0042 },
            { path: '/fivecieclebook/gorinsyo0043', component: gorinsyo0043 },
            { path: '/fivecieclebook/gorinsyo0044', component: gorinsyo0044 },
            { path: '/fivecieclebook/gorinsyo0045', component: gorinsyo0045 },
            { path: '/fivecieclebook/gorinsyo0046', component: gorinsyo0046 },
            { path: '/fivecieclebook/gorinsyo0047', component: gorinsyo0047 },
            { path: '/fivecieclebook/gorinsyo0048', component: gorinsyo0048 },
            { path: '/fivecieclebook/gorinsyo0049', component: gorinsyo0049 },
            { path: '/fivecieclebook/gorinsyo0050', component: gorinsyo0050 },
            { path: '/fivecieclebook/gorinsyo0051', component: gorinsyo0051 },
            { path: '/fivecieclebook/gorinsyo0052', component: gorinsyo0052 },
            { path: '/fivecieclebook/gorinsyo0053', component: gorinsyo0053 },
            { path: '/fivecieclebook/gorinsyo0054', component: gorinsyo0054 },
            { path: '/fivecieclebook/gorinsyo0055', component: gorinsyo0055 },
            { path: '/fivecieclebook/gorinsyo0056', component: gorinsyo0056 },
            { path: '/fivecieclebook/gorinsyo0057', component: gorinsyo0057 },
            { path: '/fivecieclebook/gorinsyo0058', component: gorinsyo0058 },
            { path: '/fivecieclebook/gorinsyo0059', component: gorinsyo0059 },
            { path: '/fivecieclebook/gorinsyo0060', component: gorinsyo0060 },
            { path: '/fivecieclebook/gorinsyo0061', component: gorinsyo0061 },
            { path: '/fivecieclebook/gorinsyo0062', component: gorinsyo0062 },
            { path: '/fivecieclebook/gorinsyo0063', component: gorinsyo0063 },
            { path: '/fivecieclebook/gorinsyo0064', component: gorinsyo0064 },
            { path: '/fivecieclebook/gorinsyo0065', component: gorinsyo0065 },
            { path: '/fivecieclebook/gorinsyo0066', component: gorinsyo0066 },
            { path: '/fivecieclebook/gorinsyo0067', component: gorinsyo0067 },
            { path: '/fivecieclebook/gorinsyo0068', component: gorinsyo0068 },
            { path: '/fivecieclebook/gorinsyo0069', component: gorinsyo0069 },
            { path: '/fivecieclebook/gorinsyo0070', component: gorinsyo0070 },
            { path: '/fivecieclebook/gorinsyo0071', component: gorinsyo0071 },
            { path: '/fivecieclebook/gorinsyo0072', component: gorinsyo0072 },
            { path: '/fivecieclebook/gorinsyo0073', component: gorinsyo0073 },
            { path: '/fivecieclebook/gorinsyo0074', component: gorinsyo0074 },
            { path: '/fivecieclebook/gorinsyo0075', component: gorinsyo0075 },
            { path: '/fivecieclebook/gorinsyo0076', component: gorinsyo0076 },
            { path: '/fivecieclebook/gorinsyo0077', component: gorinsyo0077 },
            { path: '/fivecieclebook/gorinsyo0078', component: gorinsyo0078 },
            { path: '/fivecieclebook/gorinsyo0079', component: gorinsyo0079 },
            { path: '/fivecieclebook/gorinsyo0080', component: gorinsyo0080 },
            { path: '/fivecieclebook/gorinsyo0081', component: gorinsyo0081 },
            { path: '/fivecieclebook/gorinsyo0082', component: gorinsyo0082 },
            { path: '/fivecieclebook/gorinsyo0083', component: gorinsyo0083 },
            { path: '/fivecieclebook/gorinsyo0084', component: gorinsyo0084 },
            { path: '/fivecieclebook/gorinsyo0085', component: gorinsyo0085 },
            

            
        ]
    },
    { 
        path: '/english', component: EnglishPage,
        children:[
            {path: '', component: englishdectionary},
            {path: '/english/englishdectionary', component: englishdectionary},
            {path: '/english/root/:rootId', component: rootDetail},
            {path: '/english/word/:wordId', component: wordDetail},
            {path: '/english/root-ag_act', component: root_ag_act},
            {path: '/english/practice', component: practiceModeSelect},
            {path: '/english/practice/options', component: practiceOptions},
            {path: '/english/practice/typing', component: practiceTyping},
            {path: '/english/practice/ai', component: aiRootPractice}
        ]
    },

    { 
        path: '/HTML',
        component: HTML,
        children: [
            { path: '', component: Introduction },
            { path: 'Introduction', component: Introduction },
            { path: 'Structure', component:HTML0001  },
            { path: 'Structure/Document', component: HTML0002 },
            { path: 'Structure/Elements', component:  HTML0003},
            { path: 'Structure/CommonElements', component: HTML0004 },
            { path: 'Structure/SemanticTags', component: HTML0005 },
            
        ]
    },
    
    { path: '/about', component: AboutPage },
]


const router = createRouter({
    history: createWebHistory(), 
    routes,
  });


  export default router;

